<template>
  <div class="dashboard-block m-b-none" v-if="!booking.is_offer">
    <div class="row-talent-response flex flex-col">
      <div class="flex spacer-y-2">
        <div class="w-1/2">
          <h2 v-if="!showCommentBox">Your Response</h2>
          <h2 v-else>Why are you suitable?</h2>
          <div class="flex justify-start spacer-y-1">
            <button
              v-if="(talentResponseApplied || talentResponseDeclined) && !comment && booking.talent_can_comment"
              @click="() => { this.showCommentBox = !this.showCommentBox; this.new_status = this.talent.response.status; this.new_comment = '' }"
              class="btn-link">
              <i class="fa" :class="this.showCommentBox ? 'fa-minus' : 'fa-plus'"></i> Add comment
            </button>
          </div>
        </div>
        <div class="flex flex-col w-1/2">
          <div class="btn-group btn-group-response flex justify-end align-center flex-wrap">
            <a key="apply-active" class="btn btn-accept active" v-if="talentResponseApplied && showDateAppliedFor">
              {{ $declineModuleEnabled ? $t('Applied') : 'Accepted' }} For<br>{{ talent.response.date_applied_for | date($user.date_format_preference) }}
            </a>
            <a key="apply-active" class="btn btn-accept active" v-else-if="talentResponseApplied">{{ $declineModuleEnabled ? $t('Applied') : 'Accepted' }}</a>
            <transition name="fade">
              <ladda-button
                v-if="!showCommentBox && !talentResponseApplied"
                class="btn btn-accept inactive"
                :click="handleApplyOrSubmitClicked"
                :disabled="talentCannotUpdateResponse">
                {{ bookingIsStandardPackage || !$declineModuleEnabled ? 'Accept' : $t('Apply') }}
              </ladda-button>
            </transition>

            <a key="decline-active" class="btn btn-decline active" v-if="talentResponseDeclined">Declined</a>
            <ladda-button
              v-if="talentCanDecline"
              key="decline-inactive"
              class="btn btn-decline inactive"
              :click="handleDeclineRequestCallback"
              :disabled="talentCannotUpdateResponse">
              {{ $t('Decline') }}
            </ladda-button>

            <button
              type="button"
              v-if="!talentResponseApplied && (booking.talent_can_comment || $commentModule) && clientName !== 'GSE' && !bookingIsStandardPackage"
              key="apply-comment-inactive"
              class="btn btn-secondary inactive"
              @click="() => { this.showCommentBox = !this.showCommentBox; this.new_status = 'applied'; this.new_comment = '' }"
              :disabled="talentCannotUpdateResponse"
              align="right">
              <img/>
              <span>{{ $declineModuleEnabled ? $t('Apply') : 'Accept' }} with Comment <i v-if="!showCommentBox" class="fa fa-chevron-up"></i><i v-if="showCommentBox" class="fa fa-chevron-down"></i></span>
            </button>
          </div>
        </div>
      </div>
      <div class="transition-text-area w-full spacer-b-2" v-if="showCommentBox">
        <div>
          <textarea
            name="comment"
            class="form-control comment-box response-text-area margin-b-2"
            rows="2"
            ref="comment_text_area"
            v-model="$v.new_comment.$model"
            :placeholder="$t('I would be great for this ' + $t('request') + ' because...')"></textarea>
          <vuelidate-help class="error-colour margin-b-1" :field="$v.new_comment" label="Comment" />
          <div class="btn-group flex justify-end -margin-t-1">
            <button class="btn btn-sm btn-default margin-r-1" @click="() => { this.showCommentBox = false }">
              Cancel
            </button>
            <ladda-button
              v-if="new_comment && new_comment.length"
              :disabled="talentCannotUpdateResponse"
              class="btn btn-success inactive btn-sm"
              :click="handleCommentSubmitted">
              {{ comment ? 'Update' : 'Submit' }}
            </ladda-button>
          </div>
        </div>
      </div>
      <div v-if="comment && comment.length && booking.talent_can_comment && !showCommentBox" class="w-full comment flex align-center">
        <div class="w-full spacer-r-3">
          <h3>Your Comment</h3>
          <i>{{ talent.response.comment }}</i>
          <div  class="commenter">
            <span v-if="$userIsClient">Updated </span>
            <span v-else>Updated By {{responseUpdatedBy | sentenceCase}} </span>
            <span> - {{responseUpdatedAt}} </span>
          </div>
        </div>

        <button class="btn btn-default inactive flex-shrink-0 btn-sm margin-r-1" @click="() => { this.showCommentBox = !this.showCommentBox; this.new_status = this.talent.response.status; this.new_comment = this.comment }">
          <i class="fa fa-pencil"></i> Edit Comment
        </button>
        <ladda-button
          key="delete-comment"
          class="btn btn-danger inactive flex-shrink-0 btn-sm"
          :click="handleDeleteCommentCallback"
          :disabled="talentCannotUpdateResponse">
          <i class="fa fa-trash"></i> Delete Comment
        </ladda-button>
      </div>
    </div>

    <booking-talent-response-decline-modal
      ref="modal"
      v-model="declineRequestReason"
      @comment-added="(comment) => { this.declineComment = comment; this.decline_modal_submitted = true }"
      :booking="booking"/>

    <booking-talent-date-applied-for-modal
      v-if="booking.has_date_options_only"
      v-model="dateAppliedFor"
      :dates="booking.date_options"
      :booking="booking"
      :talentId="$user.id"/>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { find, forIn, each } from 'lodash'
import { helpers } from 'mixins/bookings'
import { notify } from 'utils'
import BookingTalentResponseDeclineModal from './BookingTalentResponseDeclineModal'
import BookingTalentDateAppliedForModal from './BookingTalentDateAppliedForModal'
import $ from 'jquery'
import { required } from 'vuelidate/lib/validators'
import VuelidateHelp from '../misc/VuelidateHelp'
import { OpportunityTracker } from 'mixins/analytics'
import moment from 'moment-timezone'

export default {

  mixins: [helpers, OpportunityTracker],

  validations: {
    new_comment: {
      required,
      notEmail (value) {
        return !value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i)
      },
      notPhone (value) {
        return !value.match(/[0-9 -]{9,}/)
      },
      notBudget (value) {
        return !value.match(/\$[0-9]+/)
      }
    }
  },

  components: {
    BookingTalentResponseDeclineModal,
    BookingTalentDateAppliedForModal,
    VuelidateHelp
  },

  props: {
    booking: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      declineRequestPromise: null,
      declineRequestReason: null,
      decline_modal_submitted: false,
      showCommentBox: false,
      declineComment: null,
      new_comment: '',
      dateAppliedForPromise: null,
      dateAppliedFor: null,
      new_status: null
    }
  },

  computed: {

    comment () {
      return this.booking.talent[0] ? ((this.booking.talent[0].response.comment !== null) ? this.booking.talent[0].response.comment : null) : null
    },

    /*
     * Whether to show the date_applied_for in 'Book Talent' and 'Talent Applied'
     *
     * @return boolean
     */
    showDateAppliedFor () {
      return this.talent.response.date_applied_for && this.booking.date_options && this.booking.date_options.length
    },

    /**
     * Grab the logged in talent off of the bookings talent.
     *
     * The talents response will be part of the "response" pivot table which is the "booking_talent" table
     * on the backend. This pivot contains the status of our talents response.
     *
     * @return object
     */
    talent () {
      return find(this.booking.talent, talent => talent.id === this.$user.id)
    },

    /**
     * Determine if talent has applied for the booking request.
     *
     * @return bool
     */
    talentResponseApplied () {
      return this.talent !== undefined &&
        this.talent.response.status === 'applied'
    },

    /**
     * Determine if talent has declined the booking request.
     *
     * @return bool
     */
    talentResponseDeclined () {
      return this.talent !== undefined &&
        this.talent.response.status === 'declined'
    },

    /**
     * Determine if the talent cannot update their response.
     *
     * @return bool
     */
    talentCannotUpdateResponse () {
      return this.bookingIsWithdrawn ||
        this.bookingTypeIsBooking
    },

    talentCanDecline () {
      if (this.booking.talent.length === 0) {
        return false
      } else if (this.talentResponseDeclined) {
        return false
      }
      if (!this.$declineModuleEnabled) {
        return false
      }

      return true
    },

    responseUpdatedBy () {
      if (this.talent && this.talent.response && this.talent.response.comment_updated_by) {
        const commenterRole = this.talent.response.comment_updated_by.role
        return (commenterRole.toLowerCase() === 'talent' || commenterRole.toLowerCase() === 'client') ? commenterRole : this.clientName
      }
    },

    responseUpdatedAt () {
      return moment.utc(this.talent.response.comment_updated_at).fromNow()
    }
  },

  mounted () {
    $(this.$refs.modal.$el).on('hidden.bs.modal', this.handleDeclineRequestModalHiddenCallback)
    $('#modal-dates-' + this.$user.id).on('hidden.bs.modal', this.handleDatesModalHiddenCallback)
    this.new_comment = this.comment
  },

  methods: {
    ...mapActions('booking/request', [
      'respondToBookingRequest',
      'acceptBookingRequest',
      'cancelBookingRequest',
      'getBookingRequest',
      'changeApplicationComment',
      'replaceRequestTalent'
    ]),

    /**
     * Show date_options modal
     */
    showDatesModal () {
      $('#modal-dates-' + this.$user.id).modal('show')
    },

    handleCommentSubmitted () {
      if (this.comment && (this.talent.response && this.talent.response.status === this.new_status)) {
        this.trackEvent(this.analytics.V2.JobCommentEditEvent)
      } else {
        this.trackEvent(this.analytics.V2.JobCommentAddEvent)
      }

      if (this.new_status === 'applied') {
        return this.handleApplyOrSubmitClicked()
      } else if (this.new_status === 'declined') {
        return this.respondToBookingRequest({ id: this.booking.id, reason: this.declineRequestReason, comment: this.new_comment, status: 'declined' }).then((response) => {
          this.showCommentBox = false
          this.replaceRequestTalent({ id: this.$user.id, talent: response.data })
        })
      }
    },

    /**
     * Open date selection modal if date_options is available and event date does not exist.
     *
     * @return Promise
     */
    handleApplyOrSubmitClicked () {
      if (this.booking.has_date_options_only) {
        this.dateAppliedFor = null
        this.showDatesModal()

        const defineDateAppliedForPromise = (resolve, reject) => {
          this.dateAppliedForPromise = { resolve, reject }
        }

        return new Promise(defineDateAppliedForPromise)
          .then(() => {
            this.showCommentBox
              ? this.handleApplyRequestCallback(this.dateAppliedFor, this.new_comment)
              : this.handleApplyRequestCallback(this.dateAppliedFor)
          })
      } else {
        return this.showCommentBox ? this.handleApplyRequestCallback(null, this.new_comment) : this.handleApplyRequestCallback(null)
      }
    },

    toggleShowCommentBox () {
      this.showCommentBox = !(this.showCommentBox)
    },

    /**
     * Handle talent applying for the request.
     *
     * @return Promise
     */
    handleApplyRequestCallback (dateAppliedFor, comment = null) {
      let payload = { id: this.booking.id, dateAppliedFor: dateAppliedFor, status: 'applied' }
      if (comment) {
        payload.comment = comment
      }
      if (this.bookingIsStandardPackage) {
        this.trackEvent(this.analytics.V2.JobPackageAcceptEvent)
        return this.acceptBookingRequest(payload)
          .then((response) => {
            this.$router.push({name: 'bookings.show', params: {id: this.booking.id}})
          }).catch(error => {
            if (error.response) {
              notify.error(error.response.data.message)
            }
          })
      } else {
        if (this.booking.talent[0] && this.booking.talent[0].response && this.booking.talent[0].response.status !== 'applied') {
          this.trackEvent(this.analytics.V2.JobApplyEvent)
        }
        return this.respondToBookingRequest(payload)
          .then((response) => {
            this.showCommentBox = false
            this.replaceRequestTalent({ id: this.$user.id, talent: response.data })
          }).catch(error => {
            console.log(error)
            if (error.response && error.response.status === 422) {
              forIn(error.response.data.errors, (errors, key) => {
                each(errors, error => (notify.error(error)))
              })
            }
            $('html, body').animate({
              scrollTop: $('.has-error:visible:first').offset().top
            }, 500)
            if (error.response) {
              notify.error(error.response.data.message)
            }
          })
      }
    },

    validateBeforeSubmit () {
      return Promise.all([
        this.$validator.validateAll().then((result) => {
          if (result) {
            return Promise.resolve()
          }
          notify.error('Could not submit your comment.')
          return Promise.reject(new Error('Validation has failed.'))
        })
      ])
    },

    /**
     * Handle talent deleting their comment.
     *
     * @return Promise
     */
    handleDeleteCommentCallback () {
      return this.changeApplicationComment({ id: this.booking.id, comment: null, talentId: this.$user.id })
        .then((response) => {
          this.replaceRequestTalent({ id: this.$user.id, talent: response.data })
          this.new_comment = null
          notify.success('Successfully deleted your comment.')
        })
    },

    /**
     * Handle talent declining a request.
     *
     * @return Promise
     */
    handleDeclineRequestCallback () {
      this.declineRequestReason = null

      $(this.$refs.modal.$el).modal('show')

      const defineDeclineRequestPromise = (resolve, reject) => {
        this.declineRequestPromise = { resolve, reject }
      }

      return new Promise(defineDeclineRequestPromise)
        .then(() => {
          if (this.comment && (this.talent.response && this.talent.response.status === this.new_status)) {
            this.trackEvent(this.analytics.V2.JobCommentEditEvent)
          } else {
            this.trackEvent(this.analytics.V2.JobCommentAddEvent)
          }

          this.trackEvent(this.analytics.V2.JobDeclineEvent)
          if (this.bookingIsStandardPackage) {
            return this.cancelBookingRequest({ id: this.booking.id, reason: this.declineRequestReason, comment: this.declineComment })
          } else {
            return this.respondToBookingRequest({ id: this.booking.id, reason: this.declineRequestReason, comment: this.declineComment, status: 'declined' })
          }
        })
        .then((response) => {
          if (this.bookingIsStandardPackage) {
            this.$router.go()
          } else {
            this.replaceRequestTalent({ id: this.$user.id, talent: response.data })
          }
        })
    },

    /**
     * Handle the decline request modal being hidden.
     *
     * @return void
     */
    handleDeclineRequestModalHiddenCallback () {
      // If our modal component emitted a decline reason then we'll resolve the promise as we'll
      // continue with declining the request.
      if (this.declineRequestReason || (this.$declineCommentModuleEnabled && this.decline_modal_submitted)) {
        this.declineRequestPromise.resolve()
        this.decline_modal_submitted = false

        // If no reason was emitted then the modal was closed so we'll reject the promise to
        // prevent the declining.
      } else {
        this.declineRequestPromise.reject()
      }

      this.declineRequestPromise = null
    },

    /**
     * Handle the dates modal being hidden.
     *
     * @return void
     */
    handleDatesModalHiddenCallback () {
      // If our modal component emitted a dateAppliedFor then we'll resolve the promise as we'll
      // continue with applying for the booking
      if (this.dateAppliedFor) {
        this.dateAppliedForPromise.resolve()

        // If no dateAppliedFor emitted then the modal was closed so we'll reject the promise to
        // prevent the applying.
      } else {
        this.dateAppliedForPromise.reject()
      }

      this.dateAppliedForPromise = null
    }
  }
}
</script>

<style scoped lang="scss">
.comment {
  position: relative;
  background-color: white;
  padding: 15px;
}
.commenter{
  color: var(--brand-default-dark);
  font-size: 12px;
}
.comment:after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 90%;
  width: 0;
  height: 0;
  border: 20px solid transparent;
  border-top-color: white;
  border-bottom: 0;
  border-left: 0;
  margin-left: -10px;
  margin-bottom: -20px;
}
</style>
